import { Box, makeStyles } from '@material-ui/core';
import { useThemeMode } from '@src/contexts/ThemeMode';
import { selectAuthenticationInfo } from '@src/selectors/user';
import { LoginSuccess } from '@src/types';
import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { NotificationsActiveIcon } from '../SvgIcons';

const LIGHT_WIDGET = 'https://announcekit.co/widgets/v2/3yB4ys';
const DARK_WIDGET = 'https://announcekit.co/widgets/v2/1AmPIs';

const SELECTORS = ['.announcekit-widget', '.announcekit-widget-header-tight'];

interface NotificationsAnnounceKitActionProps {
  displayIconText?: boolean;
}

const NotificationsAnnounceKitAction: React.FC<
  NotificationsAnnounceKitActionProps
> = ({ displayIconText }) => {
  const { spacing, textIcon, styleIcon } = useStyles();
  const { mode } = useThemeMode();
  const user: LoginSuccess = useSelector(selectAuthenticationInfo);

  useEffect(() => {
    const { id, fullName, email, role, localUserName, mobileAccess } = user;
    const { name: merchantName, id: merchantId, plan, country } = user.employer;

    const widget = mode === 'dark' ? DARK_WIDGET : LIGHT_WIDGET;

    const config = {
      widget,
      user: { id, email, name: fullName },
      data: {
        member_type: plan.code,
        role,
        merchant_name: merchantName,
        merchant_id: merchantId,
        username: localUserName,
        country: country.name,
        mobile_app_enabled: mobileAccess,
      },
      lang: 'es',
      badge: {
        style: { position: 'absolute', right: ' -5px', top: '-5px' },
      },
    };

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const instances = SELECTORS.map(selector =>
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.announcekit.push({ ...config, selector })
    );

    return () => {
      instances.forEach(async (promise: Promise<{ destroy?: () => void }>) => {
        try {
          const w = await promise;
          w?.destroy?.();
        } catch {
          /* noop */
        }
      });
    };
  }, [mode, user]);

  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        className={`announcekit-widget${
          displayIconText ? '-header-tight' : ''
        } ${spacing}`}
      >
        <Box className={styleIcon}>{NotificationsActiveIcon}</Box>
        <Box className={textIcon}>
          {displayIconText && (
            <FormattedMessage id="HeaderMenu.Notifications" />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationsAnnounceKitAction;

const useStyles = makeStyles(theme => ({
  spacing: { display: 'flex', gap: '8px', alignItems: 'center' },
  textIcon: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    fontWeight: 500,
  },
  styleIcon: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.text.secondary
        : 'rgb(63, 63, 70)',
    display: 'flex',
    justifyContent: 'center',
    width: 24,
  },
}));
